<template>
  <div>
    <v-card v-if="render">
      <v-toolbar flat>
        <h4 v-if="!showSelected">{{ $t("All Contacts") }}</h4>
        <h4 v-else>{{ $t("Selected Contacts") }}</h4>
        <v-spacer></v-spacer>
        <v-text-field
          dense
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
      <v-card-title>
        <!-- <span v-if="!showSelected">{{ title }}</span
        ><span v-else>Selected Contacts</span> -->
        <v-btn small class="mx-3" @click="showSelected = !showSelected">
          <span v-if="!showSelected">{{ $t("Selected Only") }}</span>
          <span v-else>{{ $t("Show All") }}</span>
        </v-btn>
        <v-btn small class="mx-3" @click="addContact">
          {{ $t("Add Contact") }}
        </v-btn>
        <!-- <v-btn small @click="migrate2021">Migrate new 2021 Contacts</v-btn> -->
        <v-dialog v-model="dialogBulkEdit" width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              :disabled="selected.length < 1"
            >
              Bulk Edit
            </v-btn>
          </template>

          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Bulk Edit Contacts
            </v-card-title>

            <v-card-text>
              <v-select
                v-model="bulkEditChoices.Selection_Status"
                :items="bulkEditOptions.Selection_Status"
                label="Selection Status"
              ></v-select>
              <v-select
                v-model="bulkEditChoices.Role"
                :items="bulkEditOptions.Role"
                label="Role"
              ></v-select>
              <v-select
                v-model="bulkEditChoices.Organization"
                :items="bulkEditOptions.Organization"
                label="Organization"
              ></v-select>
              <v-select
                v-model="bulkEditChoices.Group"
                :items="bulkEditOptions.Group"
                label="Group"
              ></v-select>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="dialogBulkEdit = false">
                Cancel
              </v-btn>
              <v-btn color="green" dark @click="bulkUpdate">
                Update Selected Contacts
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-spacer></v-spacer>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in contactsMenu" :key="index">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-title>

      <v-data-table
        v-if="!showSelected && render"
        v-model="selected"
        :headers="headers"
        :items="filteredContacts"
        :search="search"
        :custom-filter="customFilter"
        item-key="contact_uid"
        item-class="contact-row"
        @click:row="openContact"
        :single-select="false"
        show-select
        class="contact-list"
      >
        <template v-slot:header.data-table-select>
          <div></div>
        </template>

        <!-- <template #item.full_name="{ item }">{{ item.preferred_firstName }} {{ item.preferred_lastName }}</template> -->
        <template v-slot:[`item.full_name`]="{ item }">
          {{ item.preferred_firstName }} {{ item.preferred_lastName }}
        </template>
      </v-data-table>
      <v-data-table
        v-else
        v-model="selected"
        :headers="headers"
        :items="selected"
        :search="search"
        item-key="contact_uid"
        item-class="contact-row"
        @click:row="openContact"
        :single-select="false"
        show-select
        class="contact-list"
      >
        <template v-slot:header.data-table-select>
          <div></div>
        </template>

        <!-- <template #item.full_name="{ item }">{{ item.preferred_firstName }} {{ item.preferred_lastName }}</template> -->
        <template v-slot:[`item.full_name`]="{ item }">
          {{ item.preferred_firstName }} {{ item.preferred_lastName }}
        </template>
      </v-data-table>
    </v-card>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      right
      class="contact-drawer col-sm-12 col-md-9"
    >
      <v-toolbar flat class="elevation-0 py-5">
        <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
        <v-toolbar-title>
          {{ selectedContact.preferred_firstName }}
          {{ selectedContact.preferred_lastName }}

          <div class="subtitle-1">
            {{ selectedContact.Role }}
          </div></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <!-- <v-btn icon>
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon>mdi-heart</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn> -->

        <v-btn @click.stop="drawer = false" text>Cancel</v-btn>
        <v-btn @click.stop="saveContact" dark color="#546E7A" class="ml-1"
          >Save</v-btn
        >
      </v-toolbar>
      <v-container fluid class="py-5">
        <v-row>
          <v-col cols="12" md="12" class="align-center">
            <!-- <v-card elevation="0" class="px-5" outlined> -->
            <v-card elevation="0" outlined>
              <v-card-title>
                Personal
              </v-card-title>
              <v-card-text>
                <FormGenerator
                  name="Contact Form"
                  ref="ContactForm"
                  :config="contactProfile"
                  v-model="selectedContact"
                  :submit="saveContact"
                  :render="drawer"
                  :lazy="false"
                />
              </v-card-text>
            </v-card>
          </v-col>
          <!-- <v-col cols="12" md="6" class="align-center">
            <v-card elevation="0" class="px-5" outlined>
       
            </v-card>
          </v-col> -->
        </v-row>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<script>
/* eslint-disable */
//import { forms } from "./schema";
import firebase from "firebase";

import dbContacts from "./contact.model";
import { contactProfile, batchUpdate } from "./contact.model";
import { newData2021 } from "./contact.model";

export default {
  name: "ContactTable",
  components: {
    ChipInputBox: () => import("./components/ChipInputBox.vue"),
    FormGenerator: () => import("./components/FormGenerator2Column.vue"),
  },
  props: {
    title: {
      type: String,
      default: "Contacts",
    },
    contacts: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      contactsMenu: [
        {
          title: "Extra",
        },
        {
          title: "Extra",
        },
      ],
      render: true,
      selectedContact: {},
      // forms,
      contactProfile,
      search: "",
      selected: [],
      showSelected: false, // shows only selected
      dialogBulkEdit: false,
      bulkEditOptions: {
        Selection_Status: ["Subscribed", "Long-Listed", "Selected"],
        Group: [
          "Contractor",
          "CPC Corporate Services",
          "CPC Marketing & Brand",
          "CPC Partnerships",
          "CPC Sport",
          "Federal Government",
          "Security",
          "Sport Staff",
          "Stakeholders",
          "Communications",
          "HOC Observer Program",
          "IF Technical Official",
        ],
        Organization: [
          "Archery",
          "Athletics",
          "Badminton",
          "Goalball",
          "Judo",
          "Powerlifting",
          "Rowing",
          "Shooting",
          "Swimming",
          "Table Tennis",
          "Taekwondo",
          "Triathlon",
          "Wheelchair Basketball",
          "Wheelchair Fencing",
          "Wheelchair Rugby",
          "Wheelchair Tennis",
          "Para Alpine",
          "Para Hockey",
          "Para Snowboard",
          "Wheelchair Curling",
          "Para Biathlon",
          "Coaching Association of Canada",
          "Major Games Canada",
          "Own the Podium",
          "Government Agency",
          "Marketing Partners",
          "Supplier",
          "Canadian Olympic Committee",
          "Canadian Paralympic Committee",
        ],
        Role: [
          "Assitant Coach",
          "Assitant Chef de Mission",
          "Attendant",
          "Coach",
          "Equipment Manager",
          "Equipment Technician",
          "Executive",
          "Head Coach",
          "High Performance Director",
          "Meda Attaché",
          "Personal Coach",
          "Games Operations",
        ],
      },
      bulkEditChoices: {
        Selection_Status: null,
        Group: null,
        Organization: null,
        Role: null,
      },
      // headers: [
      //   {
      //     text: "Name",
      //     align: "start",
      //     sortable: true,
      //     value: "full_name",
      //     filterable: true,
      //   },
      //   {
      //     text: "First Name",
      //     value: "preferred_firstName",
      //     class: "d-none",
      //     cellClass: "d-none",
      //   },
      //   {
      //     text: "Last Name",
      //     value: "preferred_lastName",
      //     class: "d-none",
      //     cellClass: "d-none",
      //   },
      //   { text: "Organization", value: "Organization" },
      //   { text: "Role", value: "Role" },
      //   { text: "Email", value: "Email" },
      //   { text: "Phone", value: "Phone_Number" },
      //   { text: "Status", value: "Selection_Status" },
      //   {
      //     text: "contact_uid",
      //     value: "contact_uid",
      //     class: "d-none",
      //     cellClass: "d-none",
      //   },
      // ],
      drawer: null,
      selectValues: {},
      groupsValues: [],
      eventsValues: [],
      rowsPerPage: 10,
      rowsPerPageItems: [10, 50, 100, 500],
      max: 100,
      page: 1,
      contactData: [],
      columnFilter: {
        organization: "",
      },
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "full_name",
          filterable: true,
        },
        {
          text: "First Name",
          value: "preferred_firstName",
          class: "d-none",
          cellClass: "d-none",
        },
        {
          text: "Last Name",
          value: "preferred_lastName",
          class: "d-none",
          cellClass: "d-none",
        },
        { text: "Organization", value: "Organization" },
        { text: "Role", value: "Role" },
        { text: "Email", value: "Email" },
        { text: "Phone", value: "Phone_Number" },
        { text: "Status", value: "Selection_Status" },
        {
          text: "contact_uid",
          value: "contact_uid",
          class: "d-none",
          cellClass: "d-none",
        },
        // {
        //   text: "Dessert (100g serving)",
        //   align: "left",
        //   sortable: false,
        //   value: "name",
        //   filter: f => { return ( f + '' ).toLowerCase().includes( this[ 'name' ].toLowerCase() ) }
        // },
        // {
        //   text: "Calories",
        //   value: "calories",
        //   filter: value => {
        //     if (!this.calories) return true;
        //     return value < parseInt(this.calories);
        //   }
        // },
        // {
        //   text: "Fat (g)",
        //   value: "fat",
        //   filter: value => {
        //     if (!this.fat) return true;
        //     return value < parseInt(this.fat);
        //   }
        // },
        // {
        //   text: "Carbs (g)",
        //   value: "carbs",
        //   filter: value => {
        //     if (!this.carbs) return true;
        //     return value == parseInt(this.carbs);
        //   }
        // }
      ];
    },
    filteredContacts: {
      get: function() {
        //let contacts = this.$root.$app.data.contacts;

        // if(searchParam !=""){
        //   contacts = contacts.filter(contact => )
        // }

        return this.$app.data.contacts;
      },
    },
  },
  watch: {
    drawer(newVal) {
      if (!newVal) {
        console.log("drawer close");
        this.$refs.ContactForm.reset();
      }
    },
  },
  methods: {
    customFilter(value, search, item) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().indexOf(search) !== -1
      );
    },
    openContact(item) {
      console.log("contact click", item);
      this.drawer = !this.drawer;
      this.selectedContact = item;
    },
    addContact() {
      console.log("add Contact");
      this.drawer = true;
      this.$nextTick(() => {
        this.$refs.ContactForm.reset();
        this.selectedContact = { contact_uid: "new" };
      });
    },
    saveContact() {
      let contact = this.selectedContact;
      if (contact.contact_uid == "new") {
        console.log("new contact");
        // ADD NEW CONTACT
        dbContacts
          .add(contact)
          .then((doc) => {
            contact.contact_uid = doc.id;
            this.$store.commit("updateContact", contact);
            this.$app.alert("Your contact has been successfully added");
          })
          .catch((error) => {
            console.log("Error getting documents: ", error);
            let alert = {
              snackbar: true,
              text: "Sorry there was an issue adding your new contact",
              timeout: 3500, // any integer in ms
              color: "#ff0000",
              mode: null, // vertical / multi-line default: null
              x: null, // left / right
              y: "top", // top / bottom
              dark: true,
            };
            this.$app.alert(alert);
            return;
          });
      } else if (contact.contact_uid) {
        // UPDATE EXISTING CONTACT
        dbContacts
          .add(contact)
          .then(() => {
            // let contact_ids = this.contactData.map((item) => item.contact_uid);
            // let itemIndex = contact_ids.indexOf(
            //   this.selectedContact.contact_uid
            // );
            // let editedItem = {
            //   ...this.contactData[itemIndex],
            //   ...this.selectedContact,
            // };
            // this.contactData.splice(itemIndex, 1, editedItem);
            this.$store.commit("updateContact", contact);
            this.$app.alert("Your contact has been successfully updated");
          })
          .catch((error) => {
            console.log("Error getting documents: ", error);
            let alert = {
              snackbar: true,
              text: "Sorry there was an issue with saving the contact",
              timeout: 3500, // any integer in ms
              color: "#ff0000",
              mode: null, // vertical / multi-line default: null
              x: null, // left / right
              y: "top", // top / bottom
              dark: true,
            };
            this.$app.alert(alert);
            return;
          });
      }

      //this.$refs.ContactForm.reset();
      this.drawer = false;
    },
    getContacts() {
      dbContacts.getAll().then((contacts) => {
        this.$app.data.contacts = contacts;
        this.contactData = contacts;
      });
      this.selected = [];
      this.dialogBulkEdit;
      this.reRender();

      // var db = firebase.firestore();
      // var contactRef = db.collection("contacts");
      // var _contacts = [];
      // contactRef
      //   .get()
      //   .then((querySnapshot) => {
      //     querySnapshot.forEach((doc) => {
      //       // doc.data() is never undefined for query doc snapshots
      //       let contact = doc.data();
      //       contact["contact_uid"] = doc.id;
      //       _contacts.push(contact);
      //       console.log(doc.id, " => ", doc.data());
      //     });
      //     this.$store.state.contacts = _contacts;
      //   })
      //   .catch((error) => {
      //     console.log("Error getting documents: ", error);
      //   });
    },
    // #region // MIGRATION FUNCTIONS
    // migrate() {
    //   var db = firebase.firestore();
    //   var contactRef = db.collection("contactsV2");
    //   var obj = {};
    //   this.contactData.forEach((item) => {
    //     obj[item.contact_uid] = item;
    //   });
    //   this.contactData.forEach((item) => {
    //     contactRef
    //       .add(item)
    //       .then(() => console.log("contacts have been successfully migrated"))
    //       .catch((err) => {
    //         console.log("Problem: ", err);
    //       });
    //   });
    //   contactRef.add(obj);
    // },
    // migrate2021() {
    //   var db = firebase.firestore();

    //   var contactRef = db.collection("contactsV2");

    //   this.newData2021.forEach((item) => {
    //     contactRef.add(item);
    //   });
    //   // Commit the batch
    //   console.log("contacts2021 updated");
    //   console.log("contacts2021", this.newData2021);
    // },
    // #endregion // MIGRATION FUNCTIONS
    bulkUpdate() {
      var db = firebase.firestore();
      var batch = db.batch();
      var contactRef = db.collection("contacts");
      //let _selected = this.selected.map((item) => item.contact_uid);
      // removes any keys with a null value
      let _edits = Object.entries(this.bulkEditChoices).reduce(
        (a, [k, v]) => (v == null ? a : ((a[k] = v), a)),
        {}
      );

      this.selected.forEach((contact) => {
        let contact_uid = contact.contact_uid; // get contact_uid (aka doc id)
        batch.update(contactRef.doc(contact_uid), _edits);
      });

      batch.commit().then();
      this.getContacts();
      this.selected = [];
      this.bulkEditChoices = {
        Selection_Status: null,
        Group: null,
        Organization: null,
        Role: null,
      };
      this.dialogBulkEdit = false;
    },
    reRender() {
      this.render = false;
      this.$nextTick(() => {
        this.render = true;
      });
    },
    init() {
      let contacts = this.$app.data.contacts;
      this.contactData = contacts;

      console.log("organizations", this.organizations);
      // for (let index = 0; index < this.contactData.length; index++) {
      //   const element = this.contactData[index];
      //   element["selected"] = false; // add selected key to all contacts
      // }
    },
  },
  mounted() {
    this.init();
    //console.log("dbContacts", dbContacts);
  },
};
</script>
<style lang="scss">
.contact-drawer {
  width: 100% !important;
  max-width: 1000px !important;
}
// used in datatable to include and not show for search
.d-none {
  display: none !important;
}
.contact-list {
  tbody {
    td {
      cursor: pointer;
    }
  }
}
.contact-row {
  cursor: pointer;
}
</style>
